import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Typography,
  CardContent,
  Alert,
  AlertTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import { MaterialReactTable } from "material-react-table";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Header from "./header";
import AddIcon from "@mui/icons-material/Add";
import { apiData } from "../services/api-methods";

import API from "../APIUrls";
import PageDropdown from "./pageDD";
import Footer from "./footer";
import FullPageLoader from "./loader";

function Property() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [rowCount, setRowCount] = useState(0);
  const [tblList, setTblList] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  async function fetchData() {
    try {
      setLoading(true);
      let tempData = await apiData("get", API.property, {
        pagination: JSON.stringify(pagination),
        filters: JSON.stringify(columnFilters),
      });

      setTblList(tempData.data);
      setRowCount(tempData.pagination.totalCount);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, [globalFilter, pagination.pageIndex, columnFilters]);

  const handleEdit = (data) => {
    navigate(`/property/add/${data}`);
  };

  const handleNavigation = () => {
    navigate("/property/add");
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm(
      "This action can't be revert. Are you sure you want to delete ?"
    );

    if (confirm) {
      let tempData = await apiData("delete", API.property, { id: id });

      setMessage({
        msg: tempData.msg,
        status: tempData.statusCode === 200 ? "success" : "error",
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const columns = useMemo(() => {
    const columns = [
      {
        header: "Address",
        Cell: ({ cell, row }) => {
          return (
            <div
              onClick={() => handleEdit(row.original._id)}
              style={{ cursor: "pointer" }}
            >
              {row.original.address}
            </div>
          );
        },
      },

      {
        accessorKey: "coupon",
        header: "Coupon Code",
        Cell: ({ cell, row }) => row.original.coupon,
      },
      // {
      //   header: "Address",
      //   Cell: ({ cell, row }) => row.original.address,
      // },
      // {
      //   accessorKey: "email",
      //   header: "Email",
      //   Cell: ({ cell, row }) => row.original.email,
      // },
      // {
      //   accessorKey: "contactNo",
      //   header: "Contact Number",
      //   Cell: ({ cell, row }) => row.original.contactNo,
      // },

      {
        header: "Suburb",
        Cell: ({ cell, row }) => row.original.suburb,
      },
      {
        header: "Postal Code",
        Cell: ({ cell, row }) => row.original.postalCode,
      },
      {
        header: "Delete",
        Cell: ({ cell, row }) => {
          return (
            <div style={{ color: "#E1341E", cursor: "pointer" }}>
              <DeleteIcon onClick={() => handleDelete(row.original._id)} />
            </div>
          );
        },
      },
    ];

    return columns;
  }, []);

  if (loading) {
    return <FullPageLoader />;
  }

  return (
    <div className="main">
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}

      <Grid className="employee-form">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              List Properties
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="property/add">
                Add
              </Link>
              <Typography color="text.primary">List </Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <PageDropdown page="property" />

            <Button
              size="medium"
              variant="contained"
              style={{ background: "#426e5a" }}
              className="button_first"
              // onClick={() => {
              //   setOpen(!open);
              // }}
              onClick={() => {
                handleNavigation();
              }}
              startIcon={<AddIcon />}
            >
              Add Property
            </Button>
          </Grid>
        </Grid>
        <CardContent className="tableCOntent" sx={{ pt: 0 }}>
          <MaterialReactTable
            className="tableContentInner"
            columns={columns}
            data={tblList}
            // enableRowSelection
            getRowId={(row) => row.name}
            enableColumnFilterModes
            initialState={{ showColumnFilters: false }}
            enableRowNumbers
            rowNumberMode="original"
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              globalFilter,
              // isLoading,
              pagination,
              // showAlertBanner: isError,
              // showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              ></Box>
            )}
          />
        </CardContent>
      </Grid>

      <Footer />
    </div>
  );
}

export default Property;
